module.exports = __webpack_public_path__ + "img/conclusion5.7ac91ae7.svg";